import(/* webpackMode: "eager", webpackExports: ["FinancialManageView"] */ "/web/src/sections/sub-pages/manage/tuition-tracking/view/financial-mangement-view.tsx");
